import ClientModule from "@gqlapp/module-client-react";
import Layout from "@modules/layout";
import Home from "@modules/home";
import Article from "@modules/article";
import Video from "@modules/video";
import Photo from "@modules/photo";
const Base = new ClientModule(Layout, Home, Article, Video, Photo);
export default Base;
